import React, { useMemo } from "react";
import EnhancedMarkdown from "../enhanced/EnhancedMarkdown";

const TERM_GLOSSARY = [
  {
    term: "PWM",
    explanation: "脉冲宽度调制，通过调节高低电平占空比来控制电机速度、LED亮度等。",
  },
  {
    term: "I2C",
    explanation: "一种双线串行通信协议，常用于微控制器和传感器、显示屏等模块通信。",
  },
  {
    term: "SPI",
    explanation: "一种高速同步串行通信协议，常用于屏幕、存储器和传感器模块。",
  },
  {
    term: "GPIO",
    explanation: "通用输入输出引脚，可用于读取按键、控制LED或连接外设信号。",
  },
  {
    term: "PID",
    explanation: "比例、积分、微分控制算法，常用于温控、电机控制和自动调节系统。",
  },
  {
    term: "占空比",
    explanation: "周期信号中高电平持续时间所占比例，是理解PWM控制效果的关键参数。",
  },
  {
    term: "上拉电阻",
    explanation: "将信号线通过电阻接到高电平，避免输入悬空导致状态不稳定。",
  },
  {
    term: "串口通信",
    explanation: "按位顺序传输数据的通信方式，常用于开发板调试和模块通信。",
  },
  {
    term: "中断",
    explanation: "硬件或软件事件打断当前流程，让处理器优先响应重要事件。",
  },
  {
    term: "传感器",
    explanation: "将物理世界中的光、温度、距离、压力等量转换为电信号的器件。",
  },
  {
    term: "舵机",
    explanation: "可控制转动角度的电机模块，常用于机械臂、转向结构和小车机构。",
  },
  {
    term: "杜邦线",
    explanation: "常见实验连接线，用于开发板、面包板和传感器模块之间的临时接线。",
  },
];

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const restorePlaceholders = (text, placeholders) =>
  placeholders.reduce((result, item, index) => result.replace(`@@YBG_CODE_${index}@@`, item), text);

const protectCodeSegments = (content) => {
  const placeholders = [];
  const protectedContent = content.replace(/```[\s\S]*?```|`[^`\n]+`/g, (match) => {
    const token = `@@YBG_CODE_${placeholders.length}@@`;
    placeholders.push(match);
    return token;
  });
  return { protectedContent, placeholders };
};

const annotateTerms = (content) => {
  if (!content) return content;
  const { protectedContent, placeholders } = protectCodeSegments(content);
  const sortedTerms = [...TERM_GLOSSARY].sort((a, b) => b.term.length - a.term.length);
  let annotated = protectedContent;

  sortedTerms.forEach(({ term, explanation }) => {
    const pattern = new RegExp(`(^|[^\\w\\u4e00-\\u9fa5])(${escapeRegExp(term)})(?=$|[^\\w\\u4e00-\\u9fa5])`, "g");
    annotated = annotated.replace(pattern, (match, prefix, value) => {
      if (match.includes("groupchat-term")) return match;
      return `${prefix}<span class="groupchat-term" tabindex="0" title="${explanation}">${value}</span>`;
    });
  });

  return restorePlaceholders(annotated, placeholders);
};

const GroupChatMarkdown = ({ content, enableTerms = false, className = "", ...props }) => {
  const processedContent = useMemo(
    () => (enableTerms ? annotateTerms(content || "") : content || ""),
    [content, enableTerms]
  );

  return (
    <EnhancedMarkdown
      {...props}
      content={processedContent}
      className={className}
    />
  );
};

export default GroupChatMarkdown;
